<template>
  <div class="pc_index">
    <img class="banner" src="@/assets/imgs/pc/index_bg.png" alt="" />
    <div class="pc_page_contemt">
      <img class="logo_img" src="@/assets/imgs/pc/logo.png" alt=""  @/>
      <div class="today_hot">
        <div class="title">
          <div>近期热点</div>
          <img src="@/assets/imgs/mobile/index_title_icon.png" alt="" />
        </div>
        <div class="hot_event_box" @click="goPray">
          <div class="swiper">
            <div class="bg_content" v-if="hotEvents.length>0">
              <div class="bg_img bg_left">
                <img
                  v-if="currentEvent > 1"
                  :src="hotEvents[currentEvent - 1].coverImg"
                />
                <img v-else :src="hotEvents[hotEvents.length - 1].coverImg" />
              </div>
              <div class="bg_img bg_right">
                <img
                  v-if="currentEvent < hotEvents.length - 1"
                  :src="hotEvents[currentEvent + 1].coverImg"
                />
                <img v-else :src="hotEvents[0].coverImg" alt="" />
              </div>
            </div>
            <div
              class="swiper_handle_btn btn_left"
              @click.stop="handleChange('prev')"
            >
              <i class="iconfont icon-you"></i>
            </div>
            <div class="swiper_content" v-if="hotEvents.length>0">
              <el-carousel
                class="el_swiper"
                height="100%"
                :initial-index="currentEvent"
                @change="changeEvent"
                ref="cardShow"
              >
                <el-carousel-item
                  v-for="(item, index) in hotEvents"
                  :key="index"
                >
                  <img class="swiper_img" :src="item.coverImg" />
                </el-carousel-item>
              </el-carousel>
            </div>
            <div
              class="swiper_handle_btn btn_right"
              @click.stop="handleChange('next')"
            >
              <i class="iconfont icon-you"></i>
            </div>
          </div>
          <div class="text_info" v-if="hotEvents.length>0">
            <div>
                <div class="title" v-if="hotEvents[currentEvent]">{{ hotEvents[currentEvent].name }}</div>
                <div class="desc" v-if="hotEvents[currentEvent]">{{ hotEvents[currentEvent].subheading }}</div>
            </div>
            <div class="handle">
              <div class="handle_left">
                <img src="@/assets/imgs/mobile/worship_icon_index.png" alt="" />
                <span v-if="hotEvents[currentEvent]">{{ hotEvents[currentEvent].prayCount }}</span>
              </div>
              <div class="handle_right">
                <span>前往祈福</span>
                <i class="iconfont icon-you"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="today_hot all_event">
        <div class="title">
          <div>全部事件</div>
          <img src="@/assets/imgs/mobile/index_title_icon.png" alt="" />
        </div>
        <div class="search_row">
          <div class="search_box">
            <i class="iconfont icon-sousuo"></i>
            <input v-model="keyWord" type="text" @input="inputSearch()" placeholder="输入关键字搜索" />
            <span class="handle_search" @click="search">搜索</span>
          </div>
        </div>
        <div class="all_event_list" v-if="allList.length>0">
          <template v-if="!isEmpty">
            <div
              class="all_event_content"
              v-for="(item, index) in allList"
              :key="index"
            >
              <div class="all_event_box" @click="spacePage(item)">
                <img class="box_bg" :src="item.coverImg" alt="" />
                <div class="box_content">
                  <div class="content_title" >{{ item.name }}</div>
                  <div class="content_disc">{{ item.subheading }}</div>
                  <div class="content_handle">
                    <div class="worship_num">
                      <img src="@/assets/imgs/mobile/worship_icon.png" alt="" />
                      <span>{{ item.prayCount }}</span>
                    </div>
                    <div class="go_worship">
                      <span>前往祈福</span>
                      <span class="iconfont icon-you"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <empty-view v-else imgWidth="30%"></empty-view>
        </div>

        <div class="page_row" v-if="!isEmpty">
          <div class="page_box">
            <span
              class="iconfont icon-you right"
              @click="changePage('prev')"
            ></span>
            <div class="page_list">
              <span
                :class="currentPage - 1 == index ? 'active' : ''"
                v-for="(item, index) in totalPage"
                :key="index"
                @click="changePage('current', index)"
                >{{ item }}</span
              >
            </div>
            <span
              class="iconfont icon-you left"
              @click="changePage('next')"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showRqCode">
      <qrcode @closeRqBox='closeRqBox'></qrcode>
    </div>
    <page-bottom @openRq='openRq'></page-bottom>
  </div>
</template>
<script>
import emptyView from '@/components/empty-view'
import pageBottom from '@/components/pc-page-bottom'
import qrcode from '@/components/pc-qr-code'
import storage from '@/utils/storage'
import router from '@/router'
import { getHotspotList, getAllEventList,getSeoConfig} from '@/api/index'
export default {
 
  


  components: { pageBottom, emptyView,qrcode },
  data() {
    return {
      hotEvents: [],
      currentPage: 1,
      size: 8,
      keyWord: '', //搜索关键字
      allList: [], //全部事件列表
      isEmpty: false, //全部事件是否为空
      currentEvent: 1,
      totalPage: 0,
      showRqCode:false
    }
  },
  mounted(){
      
     

  },
  created() {
    //来源字典：0：惠民殡服小程序，1：他人分享的H5，2：公司官网，3：搜索引擎访问，4：其他
    let source = this.$route.query.source //获取访问来源
    storage.setStore({ name: 'source', content: source }) //缓存来源
    this.getHotList()
    this.getAllList()
    this.getSeoConfig()

  },
   destroyed () {
    window.removeEventListener('popstate', this.goBack, false);
  },
  methods: {
    // 设置seo关键值
    setSeo(data){
      console.log(data,"============>>>>**&&&");
      document.title = data.title||'大爱无声全民祈福';
      document.querySelector('meta[name="keywords"]').setAttribute('content', data.keyWord||'大爱无声全面祈福');
      document.querySelector('meta[name="description"]').setAttribute('content',data.desc||'大爱无声全面祈福');
    },
    // 获取事件空间首页seo配置
    getSeoConfig(){
      getSeoConfig().then(res=>{
          if(res.data.data){
              console.log(res.data.data);
              this.setSeo(res.data.data)
          }
      }).catch(err=>{
        this.$message.error(err.msg)
      })
    },
    // 
     goBack () {
        console.log("===========>>>>>监听返回");
        
    },
     // 关闭弹窗
    closeRqBox(){
       this.showRqCode=false
    },
    //打开弹窗 
    openRq(){
      console.log("弹窗打开二维码");
      this.showRqCode=true
    },
   inputSearch(e){
        console.log(e,"==========))))))",this.keyWord);
   },
    //搜索
    search() {
      this.getAllList()
    },

    //获取热点事件
    getHotList() {
      getHotspotList()
        .then((res) => {
          let list = res.data.data
          this.hotEvents = list
          if(this.hotEvents.length==1){
            this.currentEvent=0
          }
          console.log("============>>>>获取热点事件",this.hotEvents);

        })
        .catch((err) => {
          this.$message.error(err.msg)
        })
    },
    //获取热点事件
    getAllList() {
      let params = {
        seoKeyword: this.keyWord,
        page: this.currentPage,
        pageSize: this.size,
      }
      getAllEventList(params)
        .then((res) => {
          let data = res.data
          let list = data.data
          if (list.length > 0) {
            let total = data.count
            this.totalPage = Math.ceil(total / this.size)
            this.allList = list
            this.isEmpty = false
          } else {
            this.isEmpty = true
          }
        })
        .catch((err) => {
          console.log(err)
          this.$message.error(err.msg)
        })
    },
    //前往空间
    goPray() {
      console.log("===========>>>>dd");
      this.$router.push({
        path: '/space',
        query: { id: this.hotEvents[this.currentEvent].id },
      })
    },
    //前往空间
    spacePage(item) {
      console.log("=========前往",item);
      this.$router.push({ path: '/space', query: { id: item.id } })
    },
    //事件轮播图切换
    changeEvent(e) {
      this.currentEvent = e
    },
    //切换事件轮播
    handleChange(type) {
      console.log("切换",type);
      if (type == 'prev') {
        this.$refs.cardShow.prev()
      } else {
        this.$refs.cardShow.next()
      }
    },
    changePage(type, index) {
      if (type == 'current') {
        this.currentPage = index + 1
      } else if (type == 'prev') {
        if (this.currentPage == 1) {
          this.$message.warning('当前已是第一页')
        } else {
          this.currentPage--
        }
      } else {
        if (this.currentPage == this.totalPage) {
          this.$message.warning('没有更多啦')
        } else {
          this.currentPage++
        }
      }
      this.getAllList()
    },
  },
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
